export const fetchingConstants = {
    REFRESHTOKEN : 'FETCHING_REFRESHTOKEN',
};



// WEBPACK FOOTER //
// ./src/_constants/fetching.constants.js